import moment from "moment";

function TextEditor(value, edit, attributes) {
  return edit ? (
    <input type="text" {...attributes} value={value}></input>
  ) : (
    value?.toString()
  );
}

export default TextEditor;
